import { css, Theme, useTheme } from '@emotion/react'
import { FC } from 'react'

import IconError from './icons/IconError'

type Props = {
  isShowError: boolean
  error: string
}

const FieldError: FC<Props> = ({ isShowError, error }) => {
  const theme = useTheme()

  if (!isShowError) return null

  return (
    <p role='alert' css={errorTextStyle(theme)}>
      <span css={errorIconStyle()}>
        <IconError />
      </span>
      {error}
    </p>
  )
}

export default FieldError

const errorTextStyle = (theme: Theme) => css`
  display: inline-flex;
  gap: 5px;
  padding-left: 5px;
  color: ${theme.color.red};
  font-size: 14px;
  line-height: 1.7;
`

const errorIconStyle = () => css`
  margin-top: 2px;
  flex-shrink: 0;
`
